import { getDisplayToken } from '@/domain/hooks/useDisplayToken'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Token } from '@/domain/types/Token'
import { SuccessViewCheckmark } from '@/features/dialogs/common/components/success-view/SuccessViewCheckmark'
import { SuccessViewContent } from '@/features/dialogs/common/components/success-view/SuccessViewContent'
import { SuccessViewProceedButton } from '@/features/dialogs/common/components/success-view/SuccessViewProceedButton'
import { SuccessViewSummaryPanel } from '@/features/dialogs/common/components/success-view/SuccessViewSummaryPanel'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'
import { Typography } from '@/ui/atoms/typography/Typography'
import { useChainId } from 'wagmi'

export interface AddToPositionSuccessViewProps {
  token: Token
  amount: NormalizedUnitNumber
  isCollateral: boolean
  onProceed: () => void
  proceedText?: string
}

export function AddToPositionSuccessView({
  token,
  amount,
  isCollateral,
  onProceed,
  proceedText = 'Done',
}: AddToPositionSuccessViewProps) {
  const chainId = useChainId()
  const displayToken = getDisplayToken(chainId, token)

  const title = isCollateral ? 'Collateral Added' : 'Savings Added'

  return (
    <SuccessViewContent>
      <SuccessViewCheckmark isModal />
      <SuccessViewSummaryPanel title={title}>
        <div className="flex items-center gap-2">
          <TokenIcon token={token} className="h-6" />
          <span className="font-semibold">{displayToken.symbol}</span>
        </div>
        <div className="flex grow flex-col">
          <Typography className="text-right font-primary">{token.format(amount, { style: 'auto' })}</Typography>
          <Typography variant="prompt" className="text-right">
            {token.formatUSD(amount)}
          </Typography>
        </div>
      </SuccessViewSummaryPanel>
      <SuccessViewProceedButton onProceed={onProceed}>{proceedText}</SuccessViewProceedButton>
    </SuccessViewContent>
  )
}
